import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { urls } from '..';
import { byRanking } from '../data/utils/byRanking';
import { getTorneiInEvidenza } from '../data/utils/getTorneiInEvidenza';
import { usePrematchData } from './/PrematchDataProvider';
import { useIsDateSection } from '../common/IsDateSectionProvider';
import { getLabel } from '../data/labels';
import { XRouterNavigateContext } from '../common/seo/xrouter/XRouterNavigateContext';

const DEFAULT_IMAGE_PATH = `${process.env.PUBLIC_URL}/assets/images/default_highlight.jpg`;

export default function HighlightedTournaments(props) {
    const xrouterNavigateContext =  useContext(XRouterNavigateContext);
    const prematchData = usePrematchData();
    const isDateSection = useIsDateSection();
    const params = useParams();

    const sport = prematchData.sportById[props.sportId];
    const data = getTorneiInEvidenza([sport], 'ALL');
    
    const tournaments = [];
    props.categories.forEach(c =>
        c.tournaments.forEach(t => {
            if (data.tournamentsMap.has(t.uniqueId)) {
                const tournament = data.tournamentsMap.get(t.uniqueId);
                tournaments.push(tournament);
            }
        })
    );
    tournaments.sort(byRanking);

    if (tournaments.length === 0) {
        return null;
    }

    return (
        <>
            <div className="xs_highlightsHeader px-2 py-1 bg-cs7 text-cs10 font-medium text-xs uppercase">{getLabel('prematch.tournament.top_leagues')}</div>
            <div className="xs_highlightsScroller p-1 flex items-center overflow-x-auto">
                {tournaments.map(t => {
                    const category = sport.categoryById[t.categoryRef];
                
                    function handleClick() {
                        if (isDateSection) {
                            xrouterNavigateContext.navigate(`${urls.base}/${urls.prematch.base}/${urls.prematch.date}/${params.date}/${params.sportId}/${params.aggId}/${t.id}`,{data:t});
                        } else {
                            xrouterNavigateContext.navigate(`${urls.base}/${urls.prematch.base}/${urls.prematch.tournament}/${t.uniqueId}`,{data:t});
                        }
                    }

                    const imgUrl = t.backgroundImage || DEFAULT_IMAGE_PATH;

                    return (
                        <div key={t.uniqueId} className={`relative flex flex-col shrink-0 mx-1 rounded-md tournamentBox_${t.uniqueId}`} onClick={handleClick}>
                            <img className="object-fill h-24 w-24 rounded-md brightness-50" alt={t.desc} src={imgUrl} data-ref={t.uniqueId} />
                            <div className="absolute bottom-0 top-0 left-0 right-0 flex flex-col px-2 py-3">
                                <div className="grid grid-cols-[16px_1fr] gap-1 items-center mt-auto">
                                    <div className={"inline-block w-[16px] h-[16px] " + category.categoryIcon}></div>
                                    <span className="text-cs1 text-xs font-medium text-shadow-contrast-1">{t.desc?.length > 0 ? t.desc : t.descrizione}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </>
    );
}
